/* unplugin-vue-components disabled */import script from "./cusInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./cusInput.vue?vue&type=script&lang=ts&setup=true"

import "./cusInput.vue?vue&type=style&index=0&id=163fcc97&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-163fcc97"]])

export default __exports__